module.exports = __webpack_public_path__ + "img/7.bc74e43f.webp";